/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GameComplexity {
    BASIC = 'BASIC',
    INTERMEDIATE = 'INTERMEDIATE',
    COMPLICATED = 'COMPLICATED',
}
